import { InputNumber, Select } from "antd";
import React, {  useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import uuidv4 from "uuid/v4";
import "./style.css";

const Option = Select.Option;

const ArticlesFilters = ({
  contoSelected, setFieldToChange, isMonoRegime, setDrawerNature, currentExemption, setIsDrawerToClose, isLoading
}) => {

  const intl = useIntl();

  const regimes = useSelector(state => state.precog.vat.regimes);
  const accounts = useSelector(state => state.precog.detailAccounts.data?.accountingLinesByCodeApiResList);
  const destinations = useSelector(state => state.precog.vat.destinations);
  const compensationRates = useSelector(state => state.precog.vat.compensation.list);
  const exemptionNatures = useSelector(state => state.precog.vat.exemptionNatures.list);

  const [regimesList, setRegimesList] = useState([]);
  const [regimeVal, setRegimeVal] = useState(undefined);
  const [regimeExtraVal, setRegimeExtraVal] = useState(undefined);
  const [compensationList, setCompensationList] = useState([]);
  const [extraFieldList, setExtraFieldList] = useState([]);
  const [compensationVal, setCompensationVal] = useState(undefined);
  const [destinationsList, setDestinationsList] = useState([]);
  const [destinationVal, setDestinationVal] = useState(undefined);
  const [regimeFind, setRegimeFind] = useState({});
  const [accountsList, setAccountsList] = useState([]);

  useEffect(() => {
    if (!regimes?.list) return;
    const optionRegimes = [];
    regimes.list.forEach((el, index) => {
      optionRegimes.push(<Option
        key={"regimes_" + index}
        value={el.id}>{el.description}
      </Option>);
    });
    setRegimesList(optionRegimes);
  }, [regimes?.list]);

  useEffect(() => {
    if (!isMonoRegime) return;
    if (isMonoRegime !== "MULTI") {
      setRegimeVal(isMonoRegime);
      setRegimeFind(regimes.list.find(x => x.id === isMonoRegime));
    }
  }, [isMonoRegime]);

  useEffect(() => {
    if (!destinations?.list || destinations?.list.length === 0) return;
    const arrayDestination = [];
    destinations.list.map((el, index) => (
      arrayDestination.push(<Option
        key={"destinations_" + index}
        value={el.id}>{el.description}
      </Option>)
    ));
    setDestinationsList(arrayDestination);

  }, [destinations?.list]);

  useEffect(() => {
    if (!accounts) return;
    const arrayAccounts = [];
    accounts.forEach((el, index) => {
      const isCurrent = el.uuid === contoSelected;
      if (el.isPosting) {
        arrayAccounts.push(<Option
          key={"articles-accordion-select_" + el.uuid}
          value={el.uuid}
          disabled={isCurrent}
        >
          {el.accountDesc.toLowerCase()}
        </Option>);
      }
    });
    setAccountsList(arrayAccounts);

  }, [accounts]);

  useEffect(() => {
    if (!regimeFind?.values) return;
    const extraFieldOptions = [];
    regimeFind.values.forEach((el, index) => {
      extraFieldOptions.push(<Option
        key={`extra_field_option_${index}`}
        value={el}>{el}%
      </Option>);
    });
    setExtraFieldList(extraFieldOptions);
  }, [regimeFind]);

  useEffect(() => {
    if (!compensationRates) return;
    const optionCompensations = [];
    compensationRates.forEach((el, index) => {
      optionCompensations.push(<Option
        key={`compensation_option_${index}`}
        value={el.id}>{el.value}
      </Option>);
    });
    setCompensationList(optionCompensations);
  }, [compensationRates]);

  useEffect(() => {
    if (!currentExemption) return;
    renderFirstNatureOptions();
  }, [currentExemption]);

  const renderFirstNatureOptions = () => {
    let items = [];
    const findRate = exemptionNatures.find(x => x.nature === currentExemption);
    exemptionNatures.map(it => {
      if (findRate && findRate.nature === it.nature) {
        items.push(<Option
          key={"articles-accordion-select_" + uuidv4()}
          value={it.id}
          label={`0% - ${it.nature}`}
        >
          {`${it.nature} - ${it.description}`}
        </Option>);
      }
      return null;
    });
    return items;
  };

  return (
    <div data-testid="ArticlesFilters" className="articles-filters-container">
      <Select
        showSearch
        style={{
          width: 200
        }}
        disabled={isLoading}
        placeholder={intl.formatMessage({id: "preCog.accountingTab.moveTo"})}
        optionFilterProp="children"
        getPopupContainer={trigger => trigger.parentNode}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onSelect={value => { 
          setFieldToChange({ accountCode: value });
          setIsDrawerToClose(true);
        }}
      >
        {accountsList}
      </Select>
      <Select
        showSearch
        value={regimeVal}
        style={{
          width: regimeFind?.field ? 150 : 200
        }}
        disabled={isMonoRegime !== "MULTI" || isLoading}
        placeholder={intl.formatMessage({id: "preCog.accountingTab.regimeSelect"})}
        optionFilterProp="children"
        getPopupContainer={trigger => trigger.parentNode}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onSelect={val => { 
          setRegimeFind(regimes.list.find(x => x.id === val));
          const valReadable = val.replace("_", " ");
          setRegimeVal(valReadable?.charAt(0)?.toUpperCase() + valReadable?.slice(1)?.toLowerCase());
          setFieldToChange({ regimeId: val });
        }}
      >
        {regimesList}
      </Select>
      {(regimeFind?.field && regimeFind?.values[0] === "0-100") ? regimeFind?.field?.includes("compensazione") ? 
        <Select
          showSearch
          value={compensationVal}
          style={{
            width: 120
          }}
          disabled={isLoading}
          dropdownClassName="split-article-input-accordion"
          placeholder={regimeFind?.field}
          optionFilterProp="children"
          className="split-article-input"
          getPopupContainer={trigger => trigger.parentNode}
          filterOption={(input, option) => option.children.toString().indexOf(input) >= 0}
          onSelect={(val) => {
            setCompensationVal(val);
            setFieldToChange({ regimeExtraField: val });
          }}
        >
          {compensationList}
        </Select>
        :
        <InputNumber
          placeholder={regimeFind.field}
          className="split-article-input"
          style={{
            width: 120,
            padding: 0
          }}
          disabled={isLoading}
          max={100}
          min={0}
          formatter={value => (value ? `${value}%` : null)}
          parser={value => value.replace("%", "")}
          onChange={value => {
            const val = value > 100 ? 100 : value < 0 ? 0 : value;
            setRegimeExtraVal(val);
          }}
          onBlur={() => {
            setFieldToChange({ regimeExtraField: regimeExtraVal });
          }}
          value={regimeExtraVal}
        /> : null}
      {(regimeFind?.field && regimeFind?.values?.length === 3) && (
        <Select
          showSearch
          value={regimeExtraVal}
          style={{
            width: 120
          }}
          disabled={isLoading}
          dropdownClassName="split-article-input-accordion"
          placeholder={regimeFind.field}
          optionFilterProp="children"
          className="split-article-input"
          getPopupContainer={trigger => trigger.parentNode}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onSelect={value => { setFieldToChange({ regimeExtraField: value }); setRegimeExtraVal(value); }}
        >
          {extraFieldList}
        </Select>
      )}
      <Select
        showSearch
        value={destinationVal}
        style={{
          width: 200
        }}
        disabled={isLoading}
        placeholder={intl.formatMessage({id: "preCog.accountingTab.destinationSelect"})}
        optionFilterProp="children"
        getPopupContainer={trigger => trigger.parentNode}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onSelect={val => { 
          setDestinationVal(val);
          setFieldToChange({ vatDestinationId: val });
        }}
      >
        {destinationsList}
      </Select>
    </div>
  );
};

export default ArticlesFilters;
